const MIME_EXTENSIONS = {
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/webp': '.webp',
  'audio/ogg': '.ogg',
  'audio/mpeg': '.mp3',
  'audio/mp4': '.m4a',
  'video/mp4': '.mp4',
  'video/3gpp': '.3gp',
  'application/pdf': '.pdf',
};

export function classifyChatMedia(media = {}) {
  const type = String(media.type || '').toLowerCase();
  const mime = String(media.mime_type || '').split(';', 1)[0].toLowerCase();
  if (type === 'sticker' || type === 'image' || mime.startsWith('image/')) return 'image';
  if (type === 'audio' || mime.startsWith('audio/')) return 'audio';
  if (type === 'video' || mime.startsWith('video/')) return 'video';
  return 'document';
}

export function chatMediaFilename(media = {}) {
  const supplied = Array.from(String(media.filename || '').split(/[\\/]/).pop().replace(/"/g, ''))
    .filter((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127)
    .join('')
    .trim();
  const type = String(media.type || 'media').replace(/[^a-z0-9_-]/gi, '') || 'media';
  let filename = supplied || `whatsapp-${type}`;
  if (!/\.[a-z0-9]{1,10}$/i.test(filename)) {
    const mime = String(media.mime_type || '').split(';', 1)[0].toLowerCase();
    filename += MIME_EXTENSIONS[mime] || '';
  }
  return filename.slice(0, 180) || 'whatsapp-media';
}

export function splitMessageLinks(value) {
  const text = String(value || '');
  const matcher = /(?:https?:\/\/|www\.)[^\s<>"']+/gi;
  const parts = [];
  let cursor = 0;
  for (const match of text.matchAll(matcher)) {
    const index = match.index ?? 0;
    if (index > cursor) parts.push({ type: 'text', value: text.slice(cursor, index) });

    let visible = match[0];
    let trailing = '';
    while (/[.,!?;:،؛؟)\]}]$/.test(visible)) {
      trailing = visible.slice(-1) + trailing;
      visible = visible.slice(0, -1);
    }
    if (visible) {
      parts.push({
        type: 'link',
        value: visible,
        href: /^www\./i.test(visible) ? `https://${visible}` : visible,
      });
    }
    if (trailing) parts.push({ type: 'text', value: trailing });
    cursor = index + match[0].length;
  }
  if (cursor < text.length) parts.push({ type: 'text', value: text.slice(cursor) });
  return parts.length ? parts : [{ type: 'text', value: text }];
}
